<template>
    <div class="task-box task2" v-if="body_show">
        <div class="task-title">
			{{ title }}
		</div>
        <h3 class="pj-task-h3"><span>{{figure_name}}&nbsp;</span>在发展过程中，有哪些最关键的&nbsp;<span class="bt" @click="alertModule1=true">拐点</span>&nbsp;？</h3>
        <h3 class="task-small-h3">可先根据自己理解进行填写，在⼩组讨论后可重新迭代填写内容</h3>
        <div class="task_bt">
            <!-- 拐点 -->
            <div class="task_f">
                <h3 class="label">拐点1<span>（用不超过10个字进行描述）</span></h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="spinodalone" type="text" placeholder="" />
                    </div>
                </div>
                <span class="float">{{spinodalone.length}}/10</span>
            </div>
            <!-- 优势 -->
            <div class="task_f">
                <h3 class="label"><label @click="alertModule2=true">优势:</label><span>（为什么其他人没有做到？他有哪些关键的能力、资源和认知？）（最多不超过3个）</span></h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="dilemmaone" type="text" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔" />
                    </div>
                </div>
                <span class="float">{{dilemmaone.length}}/22</span>
            </div>
            <!-- 内驱 -->
            <div class="task_f">
                <h3 class="label"><label @click="alertModule3=true">内驱:</label><span>（他的价值观和内驱力是什么？在遇到问题的时候，是什么在驱动他？）（最多不超过3个）</span></h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="brokenone" type="text" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔" />
                    </div>
                </div>
                <span class="float">{{brokenone.length}}/22</span>
            </div>
            <!-- 赛道 -->
            <div class="task_f">
                <h3 class="label">赛道:<span>（他在什么细分⾏业发展？）（最多不超过3个）</span></h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="sourceone" type="text" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔" />
                    </div>
                </div>
                <span class="float">{{sourceone.length}}/22</span>
            </div>
        </div>
        <!-- 拐点二 -->
        <div class="task_bt">
            <!-- 拐点 -->
            <div class="task_f">
                <h3 class="label">拐点2<span>（用不超过10个字进行描述）</span></h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="spinodaltwo" type="text" placeholder="" />
                    </div>
                </div>
                <span class="float">{{spinodaltwo.length}}/10</span>
            </div>
            <!-- 优势 -->
            <div class="task_f">
                <h3 class="label">优势:<span>（为什么其他人没有做到？他有哪些关键的能力、资源和认知？）（最多不超过3个）</span></h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="dilemmatwo" type="text" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔" />
                    </div>
                </div>
                <span class="float">{{dilemmatwo.length}}/22</span>
            </div>
            <!-- 内驱 -->
            <div class="task_f">
                <h3 class="label">内驱:<span>（他的价值观和内驱力是什么？在遇到问题的时候，是什么在驱动他？）（最多不超过3个）</span></h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="brokentwo" type="text" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔" />
                    </div>
                </div>
                <span class="float">{{brokentwo.length}}/22</span>
            </div>
            <!-- 赛道 -->
            <div class="task_f">
                <h3 class="label">赛道:<span>（他在什么细分⾏业发展？）（最多不超过3个）</span></h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="sourcetwo" type="text" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔" />
                    </div>
                </div>
                <span class="float">{{sourcetwo.length}}/22</span>
            </div>
        </div>
        <!-- 拐点三 -->
        <div class="task_bt last-child">
            <!-- 拐点 -->
            <div class="task_f">
                <h3 class="label">拐点3<span>（用不超过10个字进行描述）</span></h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="spinodalthree" type="text" placeholder="" />
                    </div>
                </div>
                <span class="float">{{spinodalthree.length}}/10</span>
            </div>
            <!-- 优势 -->
            <div class="task_f">
                <h3 class="label">优势:<span>（为什么其他人没有做到？他有哪些关键的能力、资源和认知？）（最多不超过3个）</span></h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="dilemmathree" type="text" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔" />
                    </div>
                </div>
                <span class="float">{{dilemmathree.length}}/22</span>
            </div>
            <!-- 内驱 -->
            <div class="task_f">
                <h3 class="label">内驱:<span>（他的价值观和内驱力是什么？在遇到问题的时候，是什么在驱动他？）（最多不超过3个）</span></h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="brokenthree" type="text" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔" />
                    </div>
                </div>
                <span class="float">{{brokenthree.length}}/22</span>
            </div>
            <!-- 赛道 -->
            <div class="task_f">
                <h3 class="label">赛道:<span>（他在什么细分⾏业发展？）（最多不超过3个）</span></h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="sourcethree" type="text" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔" />
                    </div>
                </div>
                <span class="float">{{sourcethree.length}}/22</span>
            </div>
        </div>
        <!-- 提交 -->
        <div class="submitBtn">
            <van-button v-if="validationHandle()" @click="submitHandle"  class="actice" >提交</van-button>
            <van-button v-else  >提交</van-button>
        </div>
        <!-- 弹出内容1 -->
		<van-popup class="explain" v-model="alertModule1">
			<div>
				<h2>拐点</h2>
				<div class="pps">
					职业生涯中，非线性、突然跃迁成长的点。可能是一场大战的胜负手，或者是某个职业生涯的能力、职位的转换点。
				</div>
			</div>
		</van-popup>
        <!-- 弹出内容2 -->
		<van-popup class="explain" v-model="alertModule2">
			<div>
				<h2>优势</h2>
				<div class="pps">
					优势有两重意义。一种是外在优势，你做得比其他竞争对手强的部分（如小组内思路最清晰）。一种是内在优势，你的某一方面比另一方面强（如左撇子的左手比右手更灵活）。
				</div>
			</div>
		</van-popup>
        <!-- 弹出内容2 -->
		<van-popup class="explain" v-model="alertModule3">
			<div>
				<h2>内驱</h2>
				<div class="pps">
					驱动你往前推进的内在动力，每个人的驱动力都不完全相同。下面是新精英整理出来的18项常见内驱力：获得经济收入、更好福利待遇、拥有权力、安全稳定、成长机会、有挑战、能发挥优势、发展空间、开拓创新、成就满足、社会地位、认同归属、和谐关系、新鲜多样、智力刺激、助人、生活平衡、职业道德。来自：《新精英18项职业内驱力》
				</div>
			</div>
		</van-popup>
        <!-- 弹出层 -->
		<van-popup :close-on-click-overlay="false" v-model="nextModule">
			<div class="modules">
				<div class="head clearfix">
					<img @click="nextModule = false" class="close" src="@a/close.png" alt="" />
				</div>
				<div class="con-img">
					<img src="@a/pr1.png" alt="图片正在加载中..." />
				</div>
				<div class="con-text">
					任务就像消消乐，完成就好，继续加油！
				</div>
				<router-link class="next-btn" :to="{path: 'project2_task3_new', query: objArg}">去开启下一任务</router-link>
			</div>
		</van-popup>
    </div>
</template>

<script>
import { getStorage, setStorage } from "@/utils/tools"
import { getprototypedata,updateprototypedata } from "@/api/course"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            body_show:false,
            title:'T2：对标人物职业优势圆环',
            figure_name:'',
            spinodalone:'',
            dilemmaone:'',
            brokenone:'',
            sourceone:'',
            spinodaltwo:'',
            dilemmatwo:'',
            brokentwo:'',
            sourcetwo:'',
            spinodalthree:'',
            dilemmathree:'',
            brokenthree:'',
            sourcethree:'',
            alertModule1:false,
            alertModule2:false,
            alertModule3:false,
            nextModule:false,
            objArg: {
                cid: "",
                pid: "",
                id: "",
                name: ""
            }
        }
    },
    methods:{
        pullData(){
            getprototypedata({
                cid:this.$route.query.cid,
                type:"tasktwo"
            })
            .then(data => {
                this.body_show = true;
                let d = data.data;
                let path =this.$route.path;
                this.figure_name = d.figure_name;

                this.spinodalone = d.spinodalone?d.spinodalone:getStorage(path, 'spinodalone') || '';
                this.dilemmaone = d.dilemmaone?d.dilemmaone:getStorage(path, 'dilemmaone') || '';
                this.brokenone = d.brokenone?d.brokenone:getStorage(path, 'brokenone') || '';
                this.sourceone = d.sourceone?d.sourceone:getStorage(path, 'sourceone') || '';

                this.spinodaltwo = d.spinodaltwo?d.spinodaltwo:getStorage(path, 'spinodaltwo') || '';
                this.dilemmatwo = d.dilemmatwo?d.dilemmatwo:getStorage(path, 'dilemmatwo') || '';
                this.brokentwo = d.brokentwo?d.brokentwo:getStorage(path, 'brokentwo') || '';
                this.sourcetwo = d.sourcetwo?d.sourcetwo:getStorage(path, 'sourcetwo') || '';

                this.spinodalthree = d.spinodalthree?d.spinodalthree:getStorage(path, 'spinodalthree') || '';
                this.dilemmathree = d.dilemmathree?d.dilemmathree:getStorage(path, 'dilemmathree') || '';
                this.brokenthree = d.brokenthree?d.brokenthree:getStorage(path, 'brokenthree') || '';
                this.sourcethree = d.sourcethree?d.sourcethree:getStorage(path, 'sourcethree') || '';

            });
        },
        // 非空验证
        validationHandle(){
            let str_fields = [
                'spinodalone',
                'dilemmaone',
                'brokenone',
                'sourceone',
                'spinodaltwo',
                'dilemmatwo',
                'brokentwo',
                'sourcetwo',
                'spinodalthree',
                'dilemmathree',
                'brokenthree',
                'sourcethree'
            ];
            // 循环判断数组内属性内容是为空
            for(let i = 0; i < str_fields.length; i++) {
                if(this.$Validator.isEmpty(this[str_fields[i]])){
                    return false;
                }
            }
            return true;
        },
        // 提交数据
        submitHandle(){
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            updateprototypedata({
                cid:this.$route.query.cid,
                type:"tasktwo",
                cpid: this.$route.query.pid,
                cptid:this.$route.query.id,
                iscreate: 1,
                spinodalone:this.spinodalone,
                dilemmaone:this.dilemmaone,
                brokenone:this.brokenone,
                sourceone:this.sourceone,
                spinodaltwo:this.spinodaltwo,
                dilemmatwo:this.dilemmatwo,
                brokentwo:this.brokentwo,
                sourcetwo:this.sourcetwo,
                spinodalthree:this.spinodalthree,
                dilemmathree:this.dilemmathree,
                brokenthree:this.brokenthree,
                sourcethree:this.sourcethree,
            })
            .then(data => {
                this.$toast.clear();
                this.nextModule = true;
                this.objArg.cid = this.$route.query.cid;
                this.objArg.id = data.cptid;
                this.objArg.pid = this.$route.query.pid;
                this.objArg.name = encodeURIComponent(data.name);

            });
        },
        setTitle(){
            let title = this.$route.query.name;
            document.title = decodeURI(title);
        }
    },
    created(){
        this.pullData();
        this.setTitle();
        shareCon("course",this);
    },
    watch:{
        spinodalone(newVal,oldVal){
            if(newVal.length > 10) {
              this.spinodalone = newVal.slice(0, 10);
              this.$toast('最多只能输入'+10+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'spinodalone', newVal);
            }
        },
        dilemmaone(newVal,oldVal){
            if(newVal.length > 22) {
              this.dilemmaone = newVal.slice(0, 22);
              this.$toast('最多只能输入'+22+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'dilemmaone', newVal);
            }
        },
        brokenone(newVal,oldVal){
            if(newVal.length > 22) {
              this.brokenone = newVal.slice(0, 22);
              this.$toast('最多只能输入'+22+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'brokenone', newVal);
            }
        },
        sourceone(newVal,oldVal){
            if(newVal.length > 22) {
              this.sourceone = newVal.slice(0, 22);
              this.$toast('最多只能输入'+22+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'sourceone', newVal);
            }
        },
        spinodaltwo(newVal,oldVal){
            if(newVal.length > 10) {
              this.spinodaltwo = newVal.slice(0, 10);
              this.$toast('最多只能输入'+10+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'spinodaltwo', newVal);
            }
        },
        dilemmatwo(newVal,oldVal){
            if(newVal.length > 22) {
              this.dilemmatwo = newVal.slice(0, 22);
              this.$toast('最多只能输入'+22+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'dilemmatwo', newVal);
            }
        },
        brokentwo(newVal,oldVal){
            if(newVal.length > 22) {
              this.brokentwo = newVal.slice(0, 22);
              this.$toast('最多只能输入'+22+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'brokentwo', newVal);
            }
        },
        sourcetwo(newVal,oldVal){
            if(newVal.length > 22) {
              this.sourcetwo = newVal.slice(0, 22);
              this.$toast('最多只能输入'+22+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'sourcetwo', newVal);
            }
        },
        spinodalthree(newVal,oldVal){
            if(newVal.length > 10) {
              this.spinodalthree = newVal.slice(0, 10);
              this.$toast('最多只能输入'+10+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'spinodalthree', newVal);
            }
        },
        dilemmathree(newVal,oldVal){
            if(newVal.length > 22) {
              this.dilemmathree = newVal.slice(0, 22);
              this.$toast('最多只能输入'+22+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'dilemmathree', newVal);
            }
        },
        brokenthree(newVal,oldVal){
            if(newVal.length > 22) {
              this.brokenthree = newVal.slice(0, 22);
              this.$toast('最多只能输入'+22+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'brokenthree', newVal);
            }
        },
        sourcethree(newVal,oldVal){
            if(newVal.length > 22) {
              this.sourcethree = newVal.slice(0, 22);
              this.$toast('最多只能输入'+22+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'sourcethree', newVal);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@s/taskStyle.scss";
    .task-box.task2{
        padding-bottom: 0;
        h3{
            color: #EB5032;
            font-size: 32px;
            line-height: 42px;
        }
        h3.pj-task-h3{
            color: #333;
            line-height: 1;
            margin-top: 40px;
            span{
                color: #EB5032;
            }
            span.bt{
                border-bottom: 1px solid #EB5032;
            }
        }
        h3.task-small-h3{
            margin-top: 15px;
            margin-bottom: 40px;
            color: #333;
        }
        .task_f{
            margin-top: 30px;
            .label{
                span{
                    font-size:24px;
                    color: #666;
                }
                label{
                    border-bottom: 1px solid #EB5032;
                }
            }
        }
        .task_bt{
            padding-bottom: 30px;
            border-bottom: 1px solid #CCCCCC;
        }
        .task_bt.last-child{
            padding-bottom: 0px;
            border-bottom: none;
        }
        .explain{
            width: changeRem(13)+px;
            height: auto;
            border-radius: changeRem(0.16)+px;
            background: #fff;
            text-align: center;
            padding: changeRem(0.8)+px changeRem(1.2)+px;
            h2{
                text-align: justify;
                margin-top: 0;
                font-size: changeRem(0.64)+px;
                color: #EB5032;
                font-weight: normal;
                margin-bottom: changeRem(0.2)+px;
            }
            .pps{
                color: #333;
            font-size: changeRem(0.52)+px;
            line-height: changeRem(0.8)+px;
            text-align: justify;
            }
        }
    }
</style>
